import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { NotificationDataService } from '../services/notification-data.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private loaderSvc: LoaderService, private notificationDataService: NotificationDataService) { }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status === 400 && err.error?.detail) {
          this.notificationDataService.showError(err.error?.detail);
        } else {
          this.notificationDataService.showError('An error occurred while retrieving data.');
        }
        this.stopLoaders();
        return throwError(() => new Error(JSON.stringify(err)));
      }),
    );
  }

  private stopLoaders() {
    this.loaderSvc.deactivate();
    this.loaderSvc.spinnerDeactivate();
  }
}
